// ChatContainer.js
import dayjs from 'dayjs';
import React, { forwardRef, memo } from 'react';
import Chat from './Chat';
import ReadingModeChatCollapse from './ReadingModeChats';
import { TailSpin } from 'react-loader-spinner';


const ChatContainer = forwardRef(({
  replyingToMessage,
  messagesEndRef,
  readingMode,
  chats,
  search,
  collapsedchats,
  setClickedImg,
  setShowImagePopup,
  setReplyingToMessage,
  setMessageToBeDeletedId,
  setChats,
  uid,
  handleForwardMessage,
  handleMessageCopy,
  setEditingMessageId,
  isLoading
}, ref) => {
  // console.log("Chat Container");

  return (
    <div ref={ref} className="h-full w-full px-3 md:px-9 overflow-y-auto">
      <div className="grid grid-cols-1 gap-y-3 md:gap-y-5 py-0.5 md:py-2">
        {/* DUMMY SCROLL UP */}
        <div ref={messagesEndRef} />

        {readingMode
          ? chats
            .filter((item) =>
              search === "" || item.message.toLowerCase().includes(search.toLowerCase())
            )
            .map((item) => (
              <Chat
                key={item.id}
                himself={!item.himself}
                date={
                  dayjs(item.createdAt).isSame(dayjs(), 'day')
                    ? "Today"
                    : dayjs(item.createdAt).isSame(dayjs().subtract(1, 'day'), 'day')
                      ? "Yesterday"
                      : dayjs(item.createdAt).format("DD/MM/YYYY")
                }
                timestamp={dayjs(item.createdAt).format("HH:mm:ss")}
                item={item}
                setClickedImg={setClickedImg}
                setShowImagePopup={setShowImagePopup}
                setReplyingToMessage={setReplyingToMessage}
                setMessageToBeDeletedId={setMessageToBeDeletedId}
                setChats={setChats}
                bookmarkedBy={
                  item.bookmarkedBy && item.bookmarkedBy instanceof Array
                    ? item.bookmarkedBy
                    : []
                }
                uid={uid}
                handleForwardMessage={handleForwardMessage}
                handleMessageCopy={handleMessageCopy}
                setEditingMessageId={setEditingMessageId}
              />
            ))
          : collapsedchats.map((item) => (
            <ReadingModeChatCollapse
              key={Math.random()}
              item={item}
              setClickedImg={setClickedImg}
              setShowImagePopup={setShowImagePopup}
            />
          ))}

        <div className={`w-full flex justify-center shrink-0 px-2 py-3 ${!isLoading ? "invisible" : ""}`}>
          <div className="w-10 h-10 md:w-12 md:h-12">
            <TailSpin />
          </div>
        </div>
        {/* {isLoading &&
        } */}
      </div>
    </div>
  );
});

export default memo(ChatContainer);
